import React, { useState } from "react";
import Dropdown1st2911 from "../../components/dropdown1st2911";
import styled from "styled-components";
import { FormInput } from "../../components/inputs/FormInput";
import { selectStyle } from "../../Styles/styledComponents/ReactSelect";

const Search = () => {
  const [formValue, setFormValue] = useState({
    email: "",
    phoneNumber: "",
    badgeNumber: "",
  });

  const [selectValue, setSelectValue] = useState("");
  const handleChangeSelect = (selected) => {
    // setRegisterSuccess("");
    console.log(selected.value);
    setSelectValue(selected);
    setFormValue({ ...formValue, userRole: selected.value });
  };
  const options = [
    { id: 1, label: "Badge ID", value: "BadgeId" },
    { id: 2, label: "Phone", value: "phone" },
    { id: 3, label: "Email", value: "email" },
  ];
  return (
    <>
      <FlexDivCenter>
        <Dropdown1st2911
          data={{
            value: selectValue,
            onChange: handleChangeSelect,
            placeholder: "Select...",
            options: options,
            classNamePrefix: "filter",
            width: "100%",
            customStyle: selectStyle,
          }}
        ></Dropdown1st2911>
        <FormInput
          className="test"
          data={{ name: "text", placeholder: "Search...",height:"150px" }}
        ></FormInput>
      </FlexDivCenter>
    </>
  );
};
export default Search;

const FlexDivCenter = styled.div`
  width: 70%;
  height: 10vh;
  display: flex;
  /* padding: 5px; */
  justify-content: center;
  align-items: center;
 div input{
  width:80%;
 }
`;
